var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0833 15.75C18.0833 18.0834 15.1667 19.8334 15.1667 21.5834H12.8333C12.8333 19.8334 9.91667 18.0834 9.91667 15.75C9.91667 13.4984 11.7483 11.6667 14 11.6667C16.2517 11.6667 18.0833 13.4984 18.0833 15.75ZM15.1667 22.75H12.8333V24.5H15.1667V22.75ZM22.1667 15.1667C22.1667 17.1267 21.4783 18.9117 20.3233 20.3234L21.98 21.98C22.8771 20.9331 23.5586 19.7195 23.9856 18.4086C24.4126 17.0978 24.5766 15.7155 24.4682 14.3411C24.3598 12.9667 23.9811 11.6273 23.354 10.3996C22.7268 9.17184 21.8634 8.08001 20.8133 7.18669L19.1567 8.84335C20.0964 9.60779 20.854 10.5719 21.3747 11.6656C21.8953 12.7594 22.1659 13.9553 22.1667 15.1667ZM18.6667 5.83335L14 1.16669V4.66669C11.2152 4.66669 8.54451 5.77293 6.57538 7.74207C4.60625 9.7112 3.5 12.3819 3.5 15.1667C3.5 17.7684 4.45667 20.1484 6.02 21.98L7.67667 20.3234C6.48177 18.8708 5.83 17.0475 5.83333 15.1667C5.83333 10.6634 9.49667 7.00002 14 7.00002V10.5L18.6667 5.83335Z",
    fill: "#674366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceFour);
export default __webpack_public_path__ + "static/media/serviceFour.e4a5801569e61ba63e5e0c0ff0f4c318.svg";
export { ForwardRef as ReactComponent };